enum SitePermissionTypes {
  A = 'Administrator',
  U = 'User',
  F = 'Finance',
  L = 'LIDA Data Entry',
  G = 'Grant',
}

export default SitePermissionTypes;
